/**
 * Users Module
 *
 * Handles user-specific functionality including role and status filters.
 * Form validation is handled in application.js (initUserFormValidation).
 */

import { $ } from '../utils/dom.js';

const BASE_URL = '/users';

/**
 * Apply role filter (preserves status)
 */
export function applyRoleFilter(select) {
    const role = select.value;
    const statusSelect = $('select[onchange="applyStatusFilter(this)"]');
    const status = statusSelect?.value || '';

    const params = new URLSearchParams();
    if (role) params.append('role', role);
    if (status) params.append('status', status);

    window.location.href = BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Apply status filter (preserves role)
 */
export function applyStatusFilter(select) {
    const roleSelect = $('select[onchange="applyRoleFilter(this)"]');
    const role = roleSelect?.value || '';
    const status = select.value;

    const params = new URLSearchParams();
    if (role) params.append('role', role);
    if (status) params.append('status', status);

    window.location.href = BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear filters
 */
export function clearFilters() {
    window.location.href = BASE_URL;
}

// Expose globally for legacy onclick handlers
window.applyRoleFilter = applyRoleFilter;
window.applyStatusFilter = applyStatusFilter;
window.clearFilters = window.clearFilters || clearFilters;

export default {
    applyRoleFilter,
    applyStatusFilter,
    clearFilters
};
